import { render, staticRenderFns } from "./EditionNewEdit.vue?vue&type=template&id=4e72ee8e&scoped=true&"
import script from "./EditionNewEdit.vue?vue&type=script&lang=js&"
export * from "./EditionNewEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e72ee8e",
  null
  
)

export default component.exports